import { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { ReactComponent as ThummbsUpSVG } from '../assets/icons/thumbs-up-active.svg';
import { ReactComponent as StarSVG } from '../assets/icons/star-active.svg';
import { ReactComponent as HeartSVG } from '../assets/icons/heart-active.svg';
import { ReactComponent as CloseSVG } from '../assets/icons/close-active.svg';
import { ReactComponent as LightningSVG } from '../assets/icons/lightning-active.svg';
import { ReactComponent as ArrowDownSVG } from '../assets/icons/arrow-down-default.svg';
import iphoneMockupPath from '../assets/images/iphone-mockup.png';
import appAnimationPath from '../assets/videos/students-tinder-app-animation.mp4';
import {
  Page,
  Main,
  Title,
  Heading,
  Subheading,
  FloatingIcon,
} from '../components';
import { ViewProps } from './types';
import {
  ViewHeightSection,
  IconTop,
  IconTopRight,
  IconBottomRight,
  IconBottomLeft,
  IconTopLeft,
  ScrollDown,
  ScrollytellingSection,
  StickyContent,
  AnimationText,
  MockupContent,
  AnimationMockupVideo,
  PhoneMockupImage,
  EmailNotifyForm,
  EmailInput,
  SubmitButton,
  FormResponse,
} from './styles';

const View: FunctionComponent<ViewProps> = ({
  scrollytellingElementRef,
  loginTextElementRef,
  discoverTextElementRef,
  matchesTextElementRef,
  downloadTextElementRef,
  mockupVideoElementRef,
  mockupImageElementRef,
  emailNotifyFormElementRef,
  emailInputElementRef,
  formResponseElementRef,
  onEmailNotifyFormSubmit,
}) => (
  <Page>
    <Helmet>
      <title>Tinder für Studenten</title>
      <meta name="robots" content="index" />
    </Helmet>

    <Main contentType="design">
      <ViewHeightSection>
        <Title>Tinder für Studenten</Title>
        <IconTop>
          <FloatingIcon icon={<ThummbsUpSVG />} />
        </IconTop>
        <IconTopRight>
          <FloatingIcon icon={<StarSVG />} />
        </IconTopRight>
        <IconBottomRight>
          <FloatingIcon icon={<HeartSVG />} />
        </IconBottomRight>
        <IconBottomLeft>
          <FloatingIcon icon={<CloseSVG />} />
        </IconBottomLeft>
        <IconTopLeft>
          <FloatingIcon icon={<LightningSVG />} />
        </IconTopLeft>
        <ScrollDown>
          <ArrowDownSVG /> Scroll to continue
        </ScrollDown>
      </ViewHeightSection>

      <ScrollytellingSection ref={scrollytellingElementRef}>
        <StickyContent>
          <AnimationText ref={loginTextElementRef}>
            <Heading>Log in with your student mail</Heading>
          </AnimationText>
          <AnimationText ref={discoverTextElementRef}>
            <Heading>Discover new people</Heading>
          </AnimationText>
          <AnimationText ref={matchesTextElementRef}>
            <Heading>Write with your matches</Heading>
          </AnimationText>
          <AnimationText ref={downloadTextElementRef}>
            <Heading>
              Soon available in the App Store and on Google Play
            </Heading>
          </AnimationText>
          <MockupContent>
            <AnimationMockupVideo
              ref={mockupVideoElementRef}
              src={appAnimationPath}
              muted
              playsInline
            />
            <PhoneMockupImage
              ref={mockupImageElementRef}
              src={iphoneMockupPath}
            />
          </MockupContent>
        </StickyContent>
      </ScrollytellingSection>

      <ViewHeightSection>
        <EmailNotifyForm
          ref={emailNotifyFormElementRef}
          onSubmit={onEmailNotifyFormSubmit}
        >
          <Subheading>
            Do you want to be notified as soon as we are online?
          </Subheading>
          <EmailInput
            ref={emailInputElementRef}
            placeholder="Enter your email"
            type="email"
            required
          />
          <SubmitButton type="submit">Notify me</SubmitButton>
        </EmailNotifyForm>
        <FormResponse ref={formResponseElementRef}>
          <Subheading> </Subheading>
        </FormResponse>
        <IconTop>
          <FloatingIcon icon={<LightningSVG />} />
        </IconTop>
        <IconTopRight>
          <FloatingIcon icon={<CloseSVG />} />
        </IconTopRight>
        <IconBottomRight>
          <FloatingIcon icon={<StarSVG />} />
        </IconBottomRight>
        <IconBottomLeft>
          <FloatingIcon icon={<ThummbsUpSVG />} />
        </IconBottomLeft>
        <IconTopLeft>
          <FloatingIcon icon={<HeartSVG />} />
        </IconTopLeft>
      </ViewHeightSection>
    </Main>
  </Page>
);

export default View;
